export const COMMON_LOADING_SIZE = 32;

export default {};
